var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "适用门店",
        visible: _vm.visible,
        size: "800px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "dialog-form",
          attrs: { model: _vm.formData, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "全部门店：", prop: "storeScope" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 0, "false-label": 1 },
                  on: { change: _vm.handleStoreScopeChange },
                  model: {
                    value: _vm.formData.storeScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "storeScope", $$v)
                    },
                    expression: "formData.storeScope",
                  },
                },
                [_vm._v("\n        全部门店\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formData.storeScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "指定门店:", prop: "relatedStoreIdList" } },
                _vm._l(_vm.regionStoreList, function (regionStore) {
                  return _c(
                    "el-card",
                    {
                      key: regionStore.regionId,
                      staticStyle: {
                        "margin-bottom": "10px",
                        "margin-right": "15px",
                      },
                      attrs: { "body-style": { padding: "10px" } },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "region-store-item" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                value: _vm.isRegionFullyChecked(regionStore),
                                indeterminate:
                                  _vm.isRegionIndeterminate(regionStore),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleRegionCheckAllChange(
                                    $event,
                                    regionStore
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(regionStore.regionName) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass: "store-checkbox-group",
                              on: { change: _vm.handleStoreCheckChange },
                              model: {
                                value: _vm.formData.relatedStoreIdList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "relatedStoreIdList",
                                    $$v
                                  )
                                },
                                expression: "formData.relatedStoreIdList",
                              },
                            },
                            _vm._l(regionStore.storeList, function (store) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: store.storeId,
                                  staticClass: "store-checkbox",
                                  attrs: { label: store.storeId },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(store.storeName) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "drawer-footer" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }